import { ReactElement, useState } from 'react'
import { DomainAssetsInterface } from 'shared/types/domain'
import { baseServerSideProps } from 'shared/utils/base-server-side-props'
import { WithCustomDomainResult, withCustomDomain } from 'shared/utils/with-custom-domain'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import { getAuthenticationLayout } from 'modules/authentication/layout/get-auhentication-layout'
import { RestorePasswordForm } from 'modules/authentication/restore-password/components/restore-password-form'
import { RestorePasswordFormDashboard } from 'modules/authentication/restore-password/components/restore-password-form-dashboard'

const RestorePassword = ({ hasCustomDomain }: WithCustomDomainResult) => {
  const [isSent, setIsSent] = useState(false)

  const onSuccess = () => {
    setIsSent(true)
  }

  return hasCustomDomain ? (
    <RestorePasswordForm onSuccess={onSuccess} isSent={isSent} />
  ) : (
    <RestorePasswordFormDashboard onSuccess={onSuccess} isSent={isSent} />
  )
}

export const getServerSideProps = withCustomDomain(withDomainAssets(baseServerSideProps))

RestorePassword.getLayout = (
  page: ReactElement,
  props: { domainAssets?: DomainAssetsInterface } & WithCustomDomainResult,
) =>
  getAuthenticationLayout(page, {
    titleKey: 'security.resetting.request.page_title',
    domainAssets: props.domainAssets,
    hasCustomDomain: props.hasCustomDomain,
  })

export default RestorePassword
